import React from "react";
import Styles from "./Event.module.scss";
import { Text } from "src/components/atoms/Text/Text";
import { Grid } from "src/components/atoms/Grid/Grid";
import { GridItem } from "src/components/atoms/Grid/GridRow";
import * as Event from "src/state/modules/event";

export const LocationBlock = (event: { event: Event.Event }) => {
  const eventHasNoLocation = !event.event.addressParts || event.event.addressParts.length === 0;
  if (eventHasNoLocation) return <></>;
  const mapsURL = event.event.location?.mapsURL;
  return (
    <Grid>
      <GridItem>
        <Text size={"base"} weight={"xbold"} block bottomMargin>
          Location
        </Text>
        {event.event.addressParts.map((addressPart) => (
          <Text
            key={addressPart}
            size={"base"}
            color={addressPart.substring(0, 3) === "No " ? "coolGrey" : undefined}
            className={Styles.eventLocation}
            block
          >
            {addressPart}
          </Text>
        ))}
        {mapsURL && (
          <a className={Styles.directions} href={mapsURL} target={"_blank"} rel={"noopener noreferrer"}>
            Get directions →
          </a>
        )}
      </GridItem>
    </Grid>
  );
};
